module.exports = __webpack_public_path__ + "static/headerRightBg-5385655123d4d904d62c1c1d72919531.png";